export function isEmptyValues(value) {
  return (
    value === undefined ||
    value === null ||
    (typeof value === "object" && Object.keys(value).length === 0) ||
    (typeof value === "string" && value.trim().length === 0)
  )
}

export function validateForm(state, inputs, t) {
  const params = Object.keys(inputs)

  const errors = {}
  params.forEach(v => {
    const empty = state[v] === undefined || state[v] === null || state[v] === "" || state[v] === false || state[v] === 0
    if (empty) {
      if (inputs[v].required) errors[v] = t("common.form.validation.empty")
    } else if (inputs[v].type === "email") {
      if (!validateEmail(state[v])) errors[v] = t("common.form.validation.wrong_email")
    }
  })
  return errors
}

const validateEmail = email => {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(String(email).toLowerCase())
}
